module.exports = __webpack_public_path__ + "grayscale.png?b13a25a2850f6c29ed1b8339664fcbd2";